"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PhoneAuthForm = require("./PhoneAuthForm");
Object.keys(_PhoneAuthForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PhoneAuthForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PhoneAuthForm[key];
    }
  });
});